export default __webpack_public_path__ + "static/media/09_Livingroom-Interior-Architecture-EschweilerPhotography01.c10f08d8.jpg";